
// @ts-nocheck


export const localeCodes =  [
  "fr",
  "en"
]

export const localeLoaders = {
  "fr": [{ key: "../i18n/locales/global/fr.ts", load: () => import("../i18n/locales/global/fr.ts" /* webpackChunkName: "locale__opt_buildhome_repo_i18n_locales_global_fr_ts" */), cache: true }],
  "en": [{ key: "../i18n/locales/global/en.ts", load: () => import("../i18n/locales/global/en.ts" /* webpackChunkName: "locale__opt_buildhome_repo_i18n_locales_global_en_ts" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute"
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "fr",
      "language": "fr",
      "name": "Français",
      "files": [
        "/opt/buildhome/repo/i18n/locales/global/fr.ts"
      ]
    },
    {
      "code": "en",
      "language": "en",
      "name": "English",
      "files": [
        "/opt/buildhome/repo/i18n/locales/global/en.ts"
      ]
    }
  ],
  "defaultLocale": "fr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://airetmontagne.fr",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "fr",
    "language": "fr",
    "name": "Français",
    "files": [
      {
        "path": "/opt/buildhome/repo/i18n/locales/global/fr.ts"
      }
    ]
  },
  {
    "code": "en",
    "language": "en",
    "name": "English",
    "files": [
      {
        "path": "/opt/buildhome/repo/i18n/locales/global/en.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
